import english from '@/locales/en';
import englishUnitedKingdom from '@/locales/en-GB';
import englishNewZealand from '@/locales/en-NZ';
import englishSingapore from '@/locales/en-SG';

export default {
    'en': english, //default - use for australia
    'en_GB': englishUnitedKingdom,
    'en_NZ': englishNewZealand,
    'en_SG': englishSingapore,
};
